const {ffToBasicInput} = require("./ff-to-basic-input");

exports.ffToTextInput = ffToBasicInput;
